import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearWishlist } from "../redux/wishlistSlice";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    localStorage.removeItem("verifiedZipcode");
    localStorage.removeItem("savedZipcode");
    localStorage.removeItem("verifiedZipcode_sale");
    localStorage.removeItem("verifiedZipcode_rental");
    sessionStorage.removeItem("verifiedZipcode_sale");
    sessionStorage.removeItem("verifiedZipcode_rental");
    dispatch(clearWishlist());
    navigate("/", { replace: true });
  }, [navigate, dispatch]);

  return null;
};

export default Logout;
